import React from 'react';
import { FormattedMessage } from 'react-intl';

import Button from '@material-ui/core/Button';
import Dialog from '@material-ui/core/Dialog';
import DialogActions from '@material-ui/core/DialogActions';
import DialogContent from '@material-ui/core/DialogContent';
import DialogContentText from '@material-ui/core/DialogContentText';
import DialogTitle from '@material-ui/core/DialogTitle';

class ConfirmDialog extends React.Component {
    render() {
        return (
            <Dialog
                open={true}
                onClose={() => this.props.onClose(false)}
                aria-labelledby="alert-dialog-title"
                aria-describedby="alert-dialog-description"
            >
                <DialogTitle id="alert-dialog-title">{this.props.title}</DialogTitle>
                <DialogContent>
                    <DialogContentText id="alert-dialog-description">
                        {this.props.message}
                    </DialogContentText>
                </DialogContent>
                <DialogActions>
                    <Button
                        onClick={() => this.props.onClose(false)}
                        variant="contained"
                        color="secondary"
                        className={'flex_full_row barlow_semibold padding_borders'}
                    >
                        <FormattedMessage id="cancel" />
                    </Button>
                    <Button
                        onClick={() => this.props.onClose(true)}
                        color="primary"
                        autoFocus
                        variant="contained"
                        className={'flex_full_row barlow_semibold padding_borders'}
                    >
                        <FormattedMessage id="accept" />
                    </Button>
                </DialogActions>
            </Dialog>
        );
    }
}

export default ConfirmDialog;



// WEBPACK FOOTER //
// ./src/components/complex/forms/ConfirmPopup.js